import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router'
import { ReactSVG } from 'react-svg'

import { URL_PAGE_CATALOG, URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'
import { CATEGORY_DEFAULT_ICON_PATH } from '@shared/contants/product'
import { CategoriesPreviewQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import CardLink from '@shared/ui/card-link'

import styles from './styles.module.scss'

interface CategoriesPreviewProps {
  data?: CategoriesPreviewQuery;
  loading?: boolean;
  classNameGrid?: string;
  classNameItem?: string;
  classNamePlug?: string;
  catalogLink?: ReactNode;
  withoutDifferentSize?: boolean;
}

function CategoriesSkeleton ({ classNameGrid }: { classNameGrid?: string }) {
  return (
    <div className={cn(styles.root, classNameGrid)}>
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className={cn(styles.root__item, styles.skeleton)}>
          <div className={styles.skeleton__text}></div>
          <div className={styles.skeleton__icon}></div>
        </div>
      ))}
    </div>
  )
}

export default function CategoriesPreview (props: CategoriesPreviewProps) {
  const { t: tc } = useTranslation('common')
  const {
    data,
    loading = false,
    catalogLink,
    classNameItem,
    classNameGrid,
    classNamePlug,
    withoutDifferentSize,
  } = props

  if (loading) {
    return <CategoriesSkeleton classNameGrid={classNameGrid} />
  }

  if (!data?.categories?.length) {
    return null
  }

  return (
    <div className={cn(styles.root, classNameGrid)}>
      {data?.categories?.map((c) => {
        return (
          <Link
            className={cn(
              styles.root__item,
              c?.preview_size && !withoutDifferentSize
                ? styles[c.preview_size]
                : '',
              classNameItem,
            )}
            key={c?.id}
            to={generatePath(URL_PAGE_CATALOG_1ST_LVL, { categorySlug: c?.slug as string})}
            style={c?.icon?.url ? { backgroundImage: `url(${c.icon.url})` } : undefined}
          >
            {c?.name}

            {!c?.icon?.url && (
              <ReactSVG
                className={cn(styles.root__plug, classNamePlug)}
                src={CATEGORY_DEFAULT_ICON_PATH}
                wrapper="span"
              />
            )}
          </Link>
        )
      })}

      {catalogLink && (
        <CardLink className={styles.root__card} to={URL_PAGE_CATALOG}>
          <h3 className={styles['root__all-title']}>{tc('full_catalog')}</h3>
        </CardLink>
      )}
    </div>
  )
}
